import { createFileRoute } from '@tanstack/react-router';

import { BulkEnrollStudents } from '~features/classes/ui/bulk-enroll-students';

const Component = () => {
  const { classId } = Route.useParams();
  return <BulkEnrollStudents classId={classId} />;
};

export const Route = createFileRoute(
  '/_auth/_layout/classes/$classId/bulk-enroll-students',
)({
  component: Component,
});
